import { api } from '@core/api/client'

/** As notificações da plataforma (backend/core/notificacoes/router.py). */

export type TipoDeNotificacao =
  | 'atribuido'
  | 'comentario'
  | 'mencao'
  | 'estado'
  | 'prazo'
  | 'corrida'
  | 'partilha'

export type Frequencia = 'imediato' | 'diario' | 'semanal' | 'nunca'

export interface Notificacao {
  id: string
  tipo: TipoDeNotificacao
  modulo: string
  recurso_tipo: string
  recurso_id: string
  titulo: string
  resumo: string
  /** Caminho na plataforma, sem o domínio. */
  ligacao: string
  detalhe: Record<string, unknown>
  autor_nome: string | null
  criada_em: string
  lida_em: string | null
}

export interface ListaDeNotificacoes {
  itens: Notificacao[]
  por_ler: number
}

export interface Preferencias {
  frequencias: Record<TipoDeNotificacao, Frequencia>
  tipos: { tipo: TipoDeNotificacao; nome: string; descricao: string }[]
  possiveis: { valor: Frequencia; nome: string }[]
  por_omissao: Frequencia
  email: string
}

export interface PessoaComAcesso {
  id: string
  nome: string | null
  email: string
}

/** O módulo e o projecto de um mapa de especialidades: o BCF (pelo
 *  identificador de projecto) ou a triagem partilhada (pelo id). */
export type ModuloComMapa = 'bcf' | 'clash'

export interface MapaDeEspecialidades {
  mapa: Record<string, string[]>
  pessoas: PessoaComAcesso[]
  sugeridas: string[]
}

const BASE = '/api/notificacoes'

function consulta(modulo: ModuloComMapa, contexto: string): string {
  return `modulo=${encodeURIComponent(modulo)}&contexto=${encodeURIComponent(contexto)}`
}

export const notificacoesApi = {
  listar: (porLer = false, limite = 30) =>
    api.get<ListaDeNotificacoes>(`${BASE}?por_ler=${porLer}&limite=${limite}`),
  contagem: () => api.get<{ por_ler: number }>(`${BASE}/contagem`),
  marcarLidas: (ids: string[]) => api.post<{ por_ler: number }>(`${BASE}/lidas`, { ids }),
  marcarTodasLidas: () => api.post<{ por_ler: number }>(`${BASE}/lidas`, { todas: true }),
  preferencias: () => api.get<Preferencias>(`${BASE}/preferencias`),
  gravarPreferencias: (frequencias: Partial<Record<TipoDeNotificacao, Frequencia>>) =>
    api.put<Preferencias>(`${BASE}/preferencias`, { frequencias }),
  pessoas: (modulo: ModuloComMapa, contexto: string) =>
    api.get<PessoaComAcesso[]>(`${BASE}/pessoas?${consulta(modulo, contexto)}`),
  especialidades: (modulo: ModuloComMapa, contexto: string) =>
    api.get<MapaDeEspecialidades>(`${BASE}/especialidades?${consulta(modulo, contexto)}`),
  gravarEspecialidades: (modulo: ModuloComMapa, contexto: string, mapa: Record<string, string[]>) =>
    api.put<MapaDeEspecialidades>(`${BASE}/especialidades?${consulta(modulo, contexto)}`, { mapa }),
}
